// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import loadCustomQuote from "@ces/App/Handlers/CustomQuotes/LoadCustomQuote";
import { CustomGetQuoteApiParameter, CustomQuoteModel } from "@ces/App/Services/QuoteService";
import { CustomAppState } from "@ces/App/Store/Reducers";
import { getCustomQuoteState } from "@ces/App/Store/Selectors/xQuotesSelector";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<CustomGetQuoteApiParameter, CustomQuoteModel>;

export const DispatchSetQuoteId: HandlerType = props => {
    props.dispatch({
        type: "Pages/RfqCustomQuoteDetails/SetQuoteId",
        quoteNumber: props.parameter.quoteNumber,
    } as any);
};

export const DispatchLoadQuoteIfNeeded: HandlerType = props => {
    const quoteState = getCustomQuoteState(props.getState() as CustomAppState, props.parameter.quoteNumber);
    if (!quoteState.value || !quoteState.value.quoteLineCollection) {
        props.dispatch(loadCustomQuote({ quoteNumber: props.parameter.quoteNumber }));
    }
};

export const chain = [DispatchSetQuoteId, DispatchLoadQuoteIfNeeded];

const loadCustomQuoteIfNeeded = createHandlerChainRunner(chain, "LoadQuoteIfNeeded");
export default loadCustomQuoteIfNeeded;
